export default __webpack_public_path__ + "static/media/image-map-alert.54fa7f59.gif";